import gql from 'graphql-tag'

export const PASTA_QUERY = gql`
  query GetPasta($idPasta: ID) {
    pasta(idPasta: $idPasta) {
      id
      nome
      isPublico
      breadcrumb {
        id
        nome
      }
      permissoesAcessoUsuarioLogado {
        id
        description
      }
    }
  }
`
